module.exports = __webpack_public_path__ + "static/img/about-bottomimg.7bde42f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/about-bottomimg.png
// module id = jw04
// module chunks = 0